import React, { useEffect, useState } from "react";
import {
  Link,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
// import WatchlistEmpty from "../../Assets/Images/WatchlistEmpty.png";

import { IoIosCamera, IoIosMail } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { TfiAngleRight } from "react-icons/tfi";

import UseMediaQuery from "./UseMediaQuery";
import { Sidebar1, Sidebar2 } from "./Sidebar";
// import MyWatchlist from "../MyAccount Components/MyWatchlist";
// import EditProfile from "./EditProfile";
// import MySubscription from "../MyAccount Components/MySubscription";
// import LoggedDevice from "../MyAccount Components/LoggedDevice";
// import DeleteAccount from "../MyAccount Components/DeleteAccount";
import { useDispatch, useSelector } from "react-redux";
import { IMAGE_URL } from "../Utils/baseUrl";
// import { getPaymentUser } from "../../Redux/Slice/Payment.slice";
// import TwoStepVerification from "../MyAccount Components/TwoStepVerification";
// import ParentalControl from "../MyAccount Components/ParentalControl";
import { decryptData } from "../Utils/encryption";
import { apply } from "slate";
import EditProfile from "./EditProfile";
import { getUserById } from "../Redux/Slice/user.slice";
import DeleteAccount from "./DeleteAccount";
import Orders from "./Orders";
import Wishlist from "../pages/Wishlist";
import BackgroundColor from "../component/BackgroundColor";
import { BsGrid3X3Gap, BsListUl } from "react-icons/bs";
// import MyWatchHistory from "../MyAccount Components/MyWatchHistory";

// Profile Section
const ProfileSection = ({ onEditProfile, currentUser }) => {
  const navigate = useNavigate();
  const subscription = useSelector((state) => state.payment.payment);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(getPaymentUser())
  }, [dispatch]);

  function formatSubscriptionDate(start, end) {
    const format = (date) => {
      const dateObj = new Date(date);
      const dayNum = dateObj.getDate().toString().padStart(2, "0");
      const monthStr = dateObj.toLocaleString("en-US", { month: "short" });
      const yearNum = dateObj.getFullYear();
      const timeStr = dateObj
        .toLocaleString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .replace("AM", "am")
        .replace("PM", "pm");
      return `${dayNum} ${monthStr}, ${yearNum} (${timeStr})`;
    };

    return `${format(start)} to ${format(end)}`;
  }

  function getSubscriptionStatus(endDate) {
    const now = new Date();
    const end = new Date(endDate);
    return now <= end ? "Active" : "Expired";
  }

  return (
    <>
      <div className="space-y-6 inter-font">
        <div className="bg-[#1414145d] backdrop-blur-md border-[2px] border-[#fff]/15 rounded p-[8px] sm:p-[15px] gap-1 md:gap-4">
          <EditProfile />
        </div>
      </div>
    </>
  );
};

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isDesktop = UseMediaQuery("(min-width: 768px)");

  useEffect(() => {
    document.title = 'Profile • YOYO';
    window.scrollTo(0, 0);
  }, []);

  const [viewMode, setViewMode] = useState("card");

  const currentUser = useSelector((state) => state.user.currUser);
  const pathToId = {
    "/profile": "my-profile",
    "/profile/edit-profile": "edit-profile",
    "/profile/orders": "orders",
    "/profile/device": "device",
    "/profile/password": "password",
    "/profile/twostep": "twostep",
    "/profile/parentalcontrol": "parentalcontrol",
    "/profile/watchHistory": "watchHistory",
    "/profile/delete": "delete",
    "/profile/logout": "logout",
  };

  const activeItem = pathToId[location.pathname] || "my-profile";
  useEffect(() => {
    if (localStorage.getItem("yoyouserId")) {
      dispatch(getUserById(localStorage.getItem("yoyouserId")));
    }
  }, [dispatch]);

  const getActiveLabel = () => {
    if (activeItem === "edit-profile") return "Edit Profile";
    return (
      {
        "my-profile": "My Profile",
        orders: "My Orders",
        password: "Change Password",
        twostep: "Two Step Verification",
        parentalcontrol: "Parental Control",
        delete: "Delete Account",
        logout: "Logout",
      }[activeItem] || ""
    );
  };

  // console.log(activeItem, "activeItem");

  return (
    <BackgroundColor className="pt-10 ">
      <div className=" text-white inter-font relative min-h-screen py-4 pt-[75px] 3xl:pt-[100px] mx-auto w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%]">
        <div className="flex flex-col min-h-[85vh] md:flex-row mx-auto max-w-[1750px] pb-[26px]">
          <div className="sidebar ">
            {isDesktop ? (
              <Sidebar1 activeItem={activeItem} />
            ) : (
              <Sidebar2 activeItem={activeItem} />
            )}
          </div>
          <main className="w-full overflow-x-auto">
            <div className="min-h-12 flex items-center justify-between text-base sm:text-lg text-white/40 mb-4">
              <div className="flex items-center justify-between text-base sm:text-lg text-white/40">
                <Link to="/" className="hover:text-white cursor-none">
                  Home
                </Link>
                {activeItem === "edit-profile" && (
                  <>
                    <span className="mx-2">
                      <TfiAngleRight className="text-white/50" />
                    </span>
                    <span
                      onClick={() => navigate("/profile")}
                      className="hover:text-white"
                    >
                      My Profile
                    </span>
                  </>
                )}
                <span className="mx-2">
                  <TfiAngleRight className="text-white/50" />
                </span>
                <span className="text-white">{getActiveLabel()}</span>
              </div>
              {activeItem === "orders" && (
                <div className="flex items-center gap-2">
                  <button
                    className={`p-3 rounded-lg font-semibold transition text-xl flex items-center justify-center ${viewMode === "card"
                      ? "bg-purple-600 text-white shadow"
                      : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                      }`}
                    onClick={() => setViewMode("card")}
                    aria-label="Card View"
                  >
                    <BsGrid3X3Gap />
                  </button>
                  <button
                    className={`p-3 rounded-lg font-semibold transition text-xl flex items-center justify-center ${viewMode === "list"
                      ? "bg-purple-600 text-white shadow"
                      : "bg-white/10 text-gray-300 hover:bg-purple-600 hover:text-white"
                      }`}
                    onClick={() => setViewMode("list")}
                    aria-label="List View"
                  >
                    <BsListUl />
                  </button>
                </div>
              )}
            </div>

            {/* ✅ Routes must be relative (no leading slashes) */}
            <Routes>
              <Route
                path=""
                element={
                  <ProfileSection
                    currentUser={currentUser}
                    onEditProfile={() => navigate("edit-profile")}
                  />
                }
              />
              <Route path="delete" element={<DeleteAccount />} />
              <Route path="orders" element={<Orders viewMode={viewMode} />} />
              <Route path="wishlist" element={<Wishlist />} />
              {/* <Route path="edit-profile" element={<EditProfile />} />
            <Route path="watchlist" element={<MyWatchlist />} />
            <Route path="subscription" element={<MySubscription />} />
            <Route path="twostep" element={<TwoStepVerification />} />
            <Route path="parentalcontrol" element={<ParentalControl />} />
            <Route path="watchHistory" element={<MyWatchHistory />} /> */}
            </Routes>
          </main>
        </div>
      </div>
    </BackgroundColor>
  );
};

export default Profile;
